import { HeaderBar } from "../components/header-bar";
import { FooterBar } from "../components/footer-bar";
import { ContentBox } from "../components/content-box";
import { Link } from "react-router-dom";

export const PageTv = () => {
  return (
    <>
      <HeaderBar />
      <ContentBox>
        <h2>Fel på TV-Mottagningen Eller Bredband</h2>

        <p>Vid fel gällande TV eller bredband:</p>

        <ul>
          <li>
            Fråga grannar om de är drabbade (att veta detta hjälper också när du
            själv ringer till Telia).
          </li>
          <li>
            Alltid kolla Telias driftinformation karta{" "}
            <Link to="https://www.telia.se/privat/driftinformation/fasttelefoni">
              som finns här
            </Link>
            .
          </li>
          <li>
            Alltid försöka att göra felsökning{" "}
            <Link to="https://www.telia.se/support/felsokning-och-driftinformation">
              som finns här
            </Link>
            .
          </li>
          <li>Annars kontaktas Telia direkt på telefon 90 200.</li>
        </ul>

        <p>
          För att vi ska kunna följa utvecklingen och få en bild av hur vårt nya
          avtal fungerar vill vi gärna att du även meddelar oss genom att maila
          till <Link to="mailto:sekr@torparangen.se">sekr@torparangen.se</Link>
        </p>
      </ContentBox>
      <FooterBar />
    </>
  );
};
